import React, { ReactNode } from 'react'
import { RadioGroup } from '@headlessui/react'
import classNames from 'classnames'
import { twMerge } from 'tailwind-merge'
import DOMPurify from 'isomorphic-dompurify'
export interface IRadioTileOption {
  key: string
  displayLabel: ReactNode
  disabled?: boolean
}

export function RadioTileGroup<T extends IRadioTileOption>({
  options,
  optionName,
  selected,
  onChange,
  radioGroupClassName,
  radioItemClassName,
}: {
  options: T[]
  optionName?: string
  onChange: (event: T) => void
  selected?: T
  radioGroupClassName?: string
  radioItemClassName?: string
}) {
  return (
    <RadioGroup
      value={selected}
      onChange={onChange}
      className={`grid gap-3 auto-rows-max place-content-stretch items-center ${
        radioGroupClassName || 'grid-cols-2 md:grid-cols-3'
      }`}
    >
      {options?.map((variantOption) => {
        const isOptionSelected = variantOption.key === selected?.key
        const isDisabled = variantOption.disabled
        return (
          <RadioGroup.Option
            value={variantOption}
            key={variantOption.key}
            className={classNames(
              'flex items-center w-full h-full focus-visible:outline-core-rose',
              {
                selected: isOptionSelected,
              }
            )}
            aria-label={`${optionName} ${variantOption.displayLabel}`}
            disabled={isDisabled}
          >
            <div
              className={twMerge(
                classNames(
                  'p-5 text-xl rounded-lg border-2 hover:cursor-pointer text-center h-full w-full flex justify-center text-acai font-mori leading-none items-center py-6',
                  {
                    'bg-pebble border-black-40': isOptionSelected,
                    'bg-core-white border-black-20': !isOptionSelected,
                    'text-core-grey-60': isDisabled,
                  },
                  radioItemClassName
                )
              )}
            >
              {typeof variantOption.displayLabel === 'string' ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(variantOption.displayLabel),
                  }}
                />
              ) : (
                variantOption.displayLabel
              )}
            </div>
          </RadioGroup.Option>
        )
      })}
    </RadioGroup>
  )
}
